import { deviceProps } from "@modules/devices/types/types-devices";
import axiosApiInstance from "@services/custom-axios-instance"
import { generateUrl } from "@services/generateUrl/generateUrl"

export async function getActiveDeviceTypes()
{
    const url = `${generateUrl()}/drproxservices/catalog/device-type`;
    const response = await axiosApiInstance.get(url);
    return response.data as deviceProps[];
}
